export * from "./dialog.component";
